import { render, staticRenderFns } from "./NativeTextareaField.vue?vue&type=template&id=928b53d0"
import script from "./NativeTextareaField.vue?vue&type=script&lang=js"
export * from "./NativeTextareaField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports